import { Water } from "@mui/icons-material";
import { intl } from "LocaleWrapper";
import { Tooltip } from "@mui/material";
import { DataFormat } from "utils";
import { getStoredRegionLocale } from "utils/regionUtils";

type CargoQuantityProps = {
	cargo: {
		weight?: number | null,
		volume?: number | null,
		isWeightPrimary: boolean,
		isVolumePrimary: boolean,
		waterLevelOptimised: boolean,
	},
	grow?: boolean,
};

const CargoQuantity = ({ cargo, grow }: CargoQuantityProps) => {
	const iconStyle = { display: "inline-flex", width: 20, justifyContent: "center" as const, flexShrink: 0 };

	const waterLevel = cargo.waterLevelOptimised ? (
		<span style={iconStyle}>
			<Tooltip title={intl.formatMessage({ id: "WATER_LEVEL_OPTIMISED" })}>
				<Water fontSize="small" color="action" />
			</Tooltip>
		</span>
	) : grow ? <span style={iconStyle} /> : null;

	const style = {
		display: "flex",
		alignItems: "center",
		flexGrow: grow ? 1 : 0,
		marginLeft: grow ? "auto" : "inherit",
		justifyContent: "flex-start",
		width: grow ? "100%" : 0,
		gap: 8,
	};

	return (
		<span style={style}>
			{waterLevel}
			<CargoQuantityField cargo={cargo} grow={grow} />
		</span>
	);
};

const CargoQuantityField = ({ cargo, grow }: CargoQuantityProps) => {
	const alignStyle = {
		display: "inline-block",
		minWidth: grow ? 35 : 0,
		textAlign: grow ? "left" as const : "inherit" as const,
	};

	const amountStyle = {
		display: "inline-block",
		minWidth: grow ? 55 : 0,
		textAlign: grow ? "right" as const : "inherit" as const,
	};

	const format = (value: number) => new Intl.NumberFormat(getStoredRegionLocale(), { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(value);
	const formatWeight = (value?: number | null) =>
		<><span style={amountStyle}>{format(value ?? 0)}</span> <span style={alignStyle}>{DataFormat.UNITS.MTON}</span></>;
	const formatVolume = (value?: number | null) =>
		<><span style={amountStyle}>{format(value ?? 0)}</span> <span style={alignStyle}>{DataFormat.UNITS.M3}</span></>;

	const weight = <span>{formatWeight(cargo.weight)}</span>;
	const volume = <span>{formatVolume(cargo.volume)}</span>;

	const valueStyle = {
		flexShrink: 0,
		whiteSpace: "nowrap",
	};

	if (cargo.isWeightPrimary && !cargo.isVolumePrimary) {
		return <span style={valueStyle}>{weight}</span>;
	} else if (!cargo.isWeightPrimary && cargo.isVolumePrimary) {
		return <span style={valueStyle}>{volume}</span>;
	} else {
		return <span style={valueStyle}>{weight} /{volume}</span>;
	}
};

export default CargoQuantity;
